<app-loader *ngIf="isDisabled"></app-loader>
<div class="modal-header">
    <h6 class="modal-title"><i class="bi bi-shield-check"></i> Advance</h6>
    <button type="button" class="btn-close" aria-label="Close" (click)="close()"></button>
</div>
<div class="modal-body">
    <form class="g-3" name="VerificationForm" (ngSubmit)="Verification(VerificationForm)" #VerificationForm="ngForm"
        novalidate>
        <div class="row">
            <div class="col-md-9 mb-3">
                <label for="TripId" class="text-label-dark">Trip</label>
                <ng-select name="ESS_TripMasterID" [items]="Trips" [(ngModel)]="Data.TripId" bindLabel="TripName"
                    bindValue="ESS_TripMasterID" placeholder="Trip" (change)="getTripDate()" required>
                </ng-select>
                <div class="invalid-feedback">
                    Please select trip
                </div>
            </div>
            <div class="col-md-3 mb-3">
                <button type="button" class="btn btn btn-outline-primary btn-sm mx-1 mt-4" (click)="addTrip()"
                    [disabled]="isDisabled"><i class="bi bi-plus" *ngIf="!isDisabled"></i>
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                        *ngIf="isDisabled"></span>
                    {{!isDisabled?'Add Trip':'Loading...'}}</button>
            </div>
            <div class="col-md-6 mb-3">
                <label for="FromDate" class="text-label-dark">From Date</label>
                <div class="input-group">
                    <input class="form-control" placeholder="DD MMM YYYY" name="FromDate" [(ngModel)]="Data.FromDate"
                        ngbDatepicker #FromDate="ngbDatepicker" required disabled />
                    <div class="invalid-feedback">
                        Please enter from date
                    </div>
                </div>
            </div>
            <div class="col-md-6 mb-3">
                <label for="ToDate" class="text-label-dark">To Date</label>
                <div class="input-group">
                    <input class="form-control" placeholder="DD MMM YYYY" name="ToDate" [(ngModel)]="Data.ToDate"
                        ngbDatepicker #ToDate="ngbDatepicker" required disabled />
                    <div class="invalid-feedback">
                        Please enter to date
                    </div>
                </div>
            </div>
            <div class="col-md-12 mb-3">
                <label for="Description" class="text-label-dark">Description</label>
                <textarea type="text" class="form-control" placeholder="Ex. 100 Main ST" id="Description"
                    name="Description" [(ngModel)]="Data.Description" #Description="ngModel" maxlength="200"
                    style="height: 70px;" disabled></textarea>
                <div class="invalid-feedback">
                    Please enter description
                </div>
            </div>
            <div class="col-md-12 mb-3">
                <label for="AdvanceAmount" class="text-label-dark">Advance Amount</label>
                <input type="text" class="form-control" placeholder="Ex. 15000" name="AdvanceAmount"
                    [(ngModel)]="Data.AdvanceAmount" #AdvanceAmount="ngModel" maxlength="5" pattern="^[0-9.]*$"
                    (keypress)="common.NumberOnly($event,common.allowDot(Data.AdvanceAmount))"
                    (keyup)="common.NumberOnly($event,common.allowDot(Data.AdvanceAmount))" required>
                <div class="invalid-feedback">
                    Please enter amount
                </div>
            </div>
        </div>
        <div class="row m-1">
            <button type="submit" class="btn btn-primary" [disabled]="isDisabled">
                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                    *ngIf="isDisabled"></span>
                {{!isDisabled?'Submit':'Loading...'}}</button>
        </div>
    </form>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-outline-secondary btn-sm" [disabled]="isDisabled" (click)="close()"><i
            class="bi bi-x" *ngIf="!isDisabled"></i>
        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true" *ngIf="isDisabled"></span>
        {{!isDisabled?'Cancel':'Loading...'}}</button>
</div>